import React from 'react';
import { StyledBackgroundImage } from 'styles/common-styled-components';

interface EventCoverImageProps {
  image: string;
}

const EventCoverImage: React.FC<EventCoverImageProps> = ({ image }) => {
  return (
    <div className="relative shadow-[0_2px_40px_rgba(0,0,0,0.32)] rounded-b-lg md:rounded-lg overflow-hidden h-[200px] sm:h-[320px] md:h-[460px] mx-[-16px] md:mx-0">
      <StyledBackgroundImage
        image={image}
        className="bg-center bg-cover w-full h-[200px] sm:h-[320px] md:h-[460px]"
      />
    </div>
  );
};

export default EventCoverImage;
